import { GreenBold } from 'components/Tables/ActivityTableV2/CellEvent/CellEventFormatter'
import { CellEventFormatterProps } from '../../utils'
import { DefaultUpdateEvent } from './DefaultUpdateEvent'

export const ReminderUpdateEvent = ({ event }: CellEventFormatterProps) => {
  // Special handling for reminder status changes
  if (event.field_name === 'status') {
    // Handle array values (event.value might be an array like ['"sent"'])
    const statusValue = Array.isArray(event.value)
      ? event.value[0]
      : event.value

    // Handle both raw string and JSON-encoded string values
    let status = statusValue as string
    if (
      typeof status === 'string' &&
      status.startsWith('"') &&
      status.endsWith('"')
    ) {
      // Remove surrounding quotes from JSON-encoded string
      status = status.slice(1, -1)
    }

    if (status === 'sent') {
      // Use bulk_size to show recipient count for sent reminders
      // The backend sets bulk_size to the recipient count when sending
      const recipientCount = event.bulk_size || 1
      return (
        <>
          sent <GreenBold>reminder</GreenBold> to{' '}
          <b>
            {recipientCount} {recipientCount === 1 ? 'recipient' : 'recipients'}
          </b>
        </>
      )
    } else if (status === 'scheduled') {
      return (
        <>
          scheduled <GreenBold>reminder</GreenBold>
        </>
      )
    } else if (status === 'failed') {
      return (
        <>
          <GreenBold>reminder</GreenBold> failed to send
        </>
      )
    } else if (status === 'deleted') {
      return (
        <>
          deleted <GreenBold>reminder</GreenBold>
        </>
      )
    }
  }

  // For other fields, use the default update event
  return <DefaultUpdateEvent event={event} />
}
